import en from './languages/en'
import nl from './languages/nl'

// TODO: Move all (event static) l10n to the db

const i18n = {
  default: 'nl',
  languages: {
    en,
    nl,
  },
} as const

export const supportedLanguages = Object.keys(
  i18n.languages,
) as SupportedLanguage[]

export type SupportedLanguage = keyof typeof i18n.languages

export type TranslationsType = typeof i18n
type Stringify<T> = {
  [K in keyof T]: T[K] extends object ? Stringify<T[K]> : string
}

export type LanguageType = Stringify<typeof nl>

export { i18n }
